module.exports = __webpack_public_path__ + "static/img/4-1.b970346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/paixu/4-1.png
// module id = E7HS
// module chunks = 6